import axiosInstance from "../axios/axiosInstance";
import { getActiveCompanyId } from "utils/companyContext";

const cid = () => getActiveCompanyId();
const unwrap = (res) => Array.isArray(res) ? res : (res?.data ?? res?.items ?? []);

export const getWorkplaces = async () => unwrap((await axiosInstance.get(`/companies/${cid()}/workplaces`)).data);
export const createWorkplace = async (p) => (await axiosInstance.post(`/companies/${cid()}/workplaces`, p)).data;
export const updateWorkplace = async ({workplaceId, ...p}) => (await axiosInstance.patch(`/companies/${cid()}/workplaces/${workplaceId}`, p)).data;
export const deleteWorkplace = async (id) => (await axiosInstance.delete(`/companies/${cid()}/workplaces/${id}`)).data;
